<template>
    <div id="content" class="screenDiv" >
        <Row>
            <Col span="24" style="padding-bottom:10px;">
                <div class="gradeBox gradeBoxOne">
                    <div class="grade">年级：</div>
                    <div class="gradeNameBox" >
                        <div class="gradeName" :class="isGrade == null?'bg':''" @click="choseGrade(null,null,null)">全部</div>
                        <div class="gradeName" v-for="(grade,index) in gradeInfo" :key="grade.id" :class="grade.id==isGrade?'bg':''" @click="choseGrade(index,grade.id,grade.gradeId)">{{grade.name}}</div>
                    </div>
                </div>
                <div class="gradeBox">
                    <div class="grade">学科：</div>
                    <div class="gradeNameBox">
                        <div class="gradeName" :class="isSubject == null?'bg':''" @click="choseSubject(null,null,null)">全部</div>
                        <div class="gradeName" v-for="(subject,index) in subjectInfo" :key="subject.id" :class="subject.id==isSubject?'bg':''"  @click="choseSubject(index,subject.id,subject.subjectId)">{{subject.name}}</div>
                    </div>
                </div>
                <div class="gradeBox" >
                    <div class="grade">类型：</div>
                    <div class="gradeNameBox">
                         <div class="gradeName" :class="isType == null?'bg':''" @click="choseStyle(null,null,null)">全部</div>
                        <div class="gradeName" v-for="(item,index) in type" :key="item.id" :class="item.id==isType?'bg':''"  @click="choseStyle(index,item.id)">{{item.name}}</div>
                    </div>
                </div>
            </Col>
        </Row>
        <div class="turnBox">
            <div class="sortFlex_area" >
                <span :class="sort == 'material'?'activeSort timeSort':'timeSort'" @click="clickSort(0)">按教材</span>
                <span><img src="/static/images/line.png" alt="" style="width:2px;height:12px;"></span>
                <span :class="sort == 'subject'?'activeSort zanSort':'zanSort'" @click="clickSort(1)">按学科</span>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../utils/api.js';
import bus from '../../assets/eventBus/enentBus.js'
export default {
    name:'microClassScreen',
    props:{     
        fromIndexRes:{
          type:Object,
          default:null
        },
    },
    data(){
        return{
            urlHttp:'/testIp',
            gradeInfo:null,                     //年级 信息
            subjectInfo:null,                   //学科 信息
            versionInfo:null,                   //版本 信息
            materialInfo:null,                  //教材 信息
            isChoseType:false,                  //是否选择 类型（备课包） 筛选条件  true 全部按钮置灰   false 全部按钮变蓝
            isGrade:null,                       //年纪筛选条件 初始默认选择全部
            isSubject:null,                     //学科筛选条件 初始默认选择全部
            isVersion:null,                     //版本筛选条件 初始默认选择全部
            isMaterial:0,                    //教材筛选条件 初始默认选择全部
            isStyle:1,                          //教材类型条件 初始默认选择全部
            isTestPaperId:null,
            isVolume:null,                      //册别类型条件 初始默认选择全部
            isType:null,                        //类型（备课包)条件 初始默认选择全部
            isOpenScreen:true,
            isOpenImgSrc:'/static/images/open.png',
            screenDiv:'150px',                            //筛选框初始高度
            isMicroClassH:false,
            gradeId:null,
            subjectId:null,
            versionId:null,
            isShowComponent:false,
            gradeList:null,                                                 //年级列表
            List:null,
            turnSreen:false,
            turnName: '切换为按教材查询',
            sort:'subject',
            type:[                                   // 类型
                {
                    name:'课件',
                    id:'2'
                },
                {
                    name:'学案',
                    id:'3'
                },
                {
                    name:'微课',
                    id:'1'
                },
                {
                    name:'其他',
                    id:'4'
                }
            ],

        }
    },
    mounted(){
        if(this.fromIndexRes != null){
          if(this.fromIndexRes.isFromIndexSyn == 'testPaper' || this.fromIndexRes.isFromIndexSyn == 'MicroClass') {
            this.isChoseSubject = true;   //判断是否有全部
          }
          if(this.fromIndexRes.isFromIndexSyn == 'SynchronizeResources') {
            if(this.fromIndexRes.subjectId == 79){
              this.isVersion = 5;
              this.versionId = 5;
            }
            if(this.fromIndexRes.subjectId == 83){
              this.isGrade = 84;
              this.gradeId = 84;
            }
            this.$nextTick(() => {
                bus.$emit('tbSubjectId',this.fromIndexRes.subjectId)
                if(this.fromIndexRes.subjectId == 79){
                  bus.$emit('tbVersionId',5)
                }
                if(this.fromIndexRes.subjectId == 83){
                  bus.$emit('tbGradeId',84)
                }

            })
          }else if(this.fromIndexRes.isFromIndexSyn == 'testPaper'){
            this.$nextTick(() => {
                bus.$emit('testSubjectId',this.fromIndexRes.subjectId)
                if(this.fromIndexRes.subjectId == 83){
                  bus.$emit('tbGradeId',84)
                }

            })
          }else if(this.fromIndexRes.isFromIndexSyn == 'MicroClass'){

            // this.$nextTick(() => {
            //     bus.$emit('subjectId',this.fromIndexRes.subjectId)
            // })
            this.$emit('subjectIdIndex',this.fromIndexRes.subjectId)
            this.isShowComponent = true;

          }
          if(this.fromIndexRes.subjectId == 83){
            this.isGrade = 84;
            this.gradeId = 84;
            this.isVersion = 4;
            this.versionId = 4;
          }
          if(this.fromIndexRes.subjectId == 81){
            this.isVersion = 4;
            this.versionId = 4;
          }
          if(!this.isAreaQuality){
              this.isSubject = this.fromIndexRes.subjectId;
              this.subjectId = this.fromIndexRes.subjectId;
          }
        }else {
          this.isChoseSubject = false;
        }
        this.getGradeList('grade_id')
        
    },
    watch:{

    },
    methods:{
        //初始化获取年级列表
        getGradeList(name,grade_id,subject_id,version_id){
            let that = this;
            const url = '/axt-data/qcr/selectQcrFuture';
            const params = {
                gradeId:grade_id,
                subjectId:subject_id,
                versionId:version_id,
                websiteId:localStorage.getItem('websiteId') || 0,
                columnName:name
            };
            api.getListAPI(url,params).then(res => {
                if(res.data.message == 'success'){
                    // that.gradeList = res.data.data;
                    const list = res.data.data; 
                    if(name == 'grade_id') that.getGradeData(list);
                    if(name == 'subject_id') that.getSubjectData(list);
                    if(name == 'version_id') that.getVersionData(list);
                }
            })
        },
        //获取年级信息 
        getGradeData(list){
            if(list.indexOf(this.gradeId) == -1){
                this.gradeId = null
                this.isGrade = null
            }
            let that = this;
            const url =  '/axt-future/grade/selectByIds';
            let params = {
                gradeIds:list + ''
            }
            api.getListAPI(url,params).then(res => {
                //数据处理
                this.gradeInfo = res.data.data;
                bus.$emit('gradeData',that.gradeInfo)           //向上传组件传值
                that.getGradeList('subject_id',that.gradeId)
             }).catch(err => {console.log(err)})
        },
        //获取学科信息 教材筛选
        getSubjectData(list){
            let that = this;
            // 二次点击年纪 没有上次所选的学科  默认为全部
            if(list.indexOf(this.subjectId) == -1){
                this.subjectId = null
                this.isSubject = null
                 let subject = {
                        id:null,
                        subjectId:null
                    }
                bus.$emit('subjectId',subject)
            }
            const url =  '/axt-future/subject/selectByIds';
            let params = {
                subjectIds:list + ''
            }
            api.getListAPI(url,params).then(res => {
                that.subjectInfo = res.data.data;
                bus.$emit('subjectData',this.subjectInfo)
            }).catch(err => {
                console.log(err)
            })
        },
        //点击年级筛选条件 字体变色
        choseGrade(index,gradeId,gradeIdLong){
            this.isGrade = gradeId;
            this.gradeId = gradeId;
            // this.getMaterialData(this.gradeId,this.subjectId,this.versionId);    //教材根据 年级 学科 版本走
            this.getGradeList('subject_id',this.gradeId); 
            let grade = {
                id:gradeId,
                gradeId:gradeIdLong
            }
            bus.$emit('gradeId',grade) 
           
        },
        //点击学科筛选条件 字体变色
        choseSubject(index,subjectId,subjectIdLong){
            this.isSubject = subjectId;
            this.subjectId = subjectId;
            // this.getGradeList('version_id',this.gradeId,this.subjectId); 
            let subject = {
                id:subjectId,
                subjectId:subjectIdLong
            }
            bus.$emit('subjectId',subject)
        },
         //点击类型筛选条件 字体变色
        choseStyle(index,styleId){
            this.isType = styleId;
            bus.$emit('stylelId',styleId)
        },
        clickSort(num) {
            if(num == 0){
               this.$emit('whichSreen',true)
            } else {
                this.$emit('whichSreen',false)
            }
        }
    }
}
</script>
<style lang="">
    .screenDiv{
        width:100%;
        border: 1px solid #DADADA;
        border-radius: 6px;
        color: #666;
        font-size: 14px;
        position: relative;
    }
    .gradeBox{
        width:100%;
        min-height: 30px;
        padding: 5px 0 0 0;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        line-height: 30px;
        white-space:normal；
    }
    .gradeBoxOne{
        padding-top: 10px;
    }
    .gradeBox .ivu-input-with-suffix{
        padding-right: 0px;
    }
    .gradeBox .ivu-input-suffix:hover{
        cursor: pointer;
    }
    .gradeNameBox{
      overflow: hidden;
    }
    .grade{
        float:left;
        min-width: 70px;
        padding-left: 5px;
    }
    .gradeName{
        float:left;
        min-width:45px;
        margin: 0 10px;
        padding: 0 5px;
        text-align: left;
    }
    .gradeName:hover{
        cursor: pointer;
        color: #343434;
        border-radius: 5px;
        background: #EEF5FF;
    }
    .isChose{
        color:#3683FF;
    }
    .openScreen{
        width:100%;
        min-height:120px;
        position: relative;
        color:#3583FF;
    }
    .openScreenBox{
         position: absolute;
        bottom: 10px;
        right:30px;
    }
    .openScreenBox:hover{
        cursor: pointer;
    }
    .isOpenImg{
        width:14px;
        height:9px;
    }
    .bg{
        color:#3583FF;
    }
    .turnBox{
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .turnBox:hover {
        color:#3583FF;
        cursor: pointer;
    }
    .activeSort{
        color: #3683FF;
    }

</style>



// WEBPACK FOOTER //
// src/components/MicroClassScreen/areaQualityResourcesScreenBySubject.vue